<div class="container">
  <div class="page-spinner" *ngIf="isRequestProccessing">
    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
  </div>
  <app-agree-license-modal *ngIf="showAgreeLicenseDialog" (confirmed)="confirmLicense()"></app-agree-license-modal>
  <div *ngIf="!showAgreeLicenseDialog" [innerHtml]="content" class="mt-5">
  </div>
</div>
